import { render } from "./SuperAdminDashboard.vue?vue&type=template&id=0a6c3420&scoped=true"
import script from "./SuperAdminDashboard.vue?vue&type=script&lang=js"
export * from "./SuperAdminDashboard.vue?vue&type=script&lang=js"

import "./SuperAdminDashboard.vue?vue&type=style&index=0&id=0a6c3420&scoped=true&lang=css"

import exportComponent from "C:\\actions-runner\\_work\\cims-billing.ui\\cims-billing.ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a6c3420"]])

export default __exports__